
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserState, IUser } from "./types";

const initialState: IUserState = {
  user: null,
  gift: null,
  partnerId: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser | null>) => {
      state.user = action.payload;
    },
    setGift: (state, action: PayloadAction<any>) => {
      state.gift = action.payload;
    },
    setPartnerId: (state, action: PayloadAction<string | number | null>) => {
      state.partnerId = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.gift = null;
      state.partnerId = null;
    },
  },
});

export const { setUser, setGift, setPartnerId, clearUser } = userSlice.actions;

export default userSlice.reducer;

